export const pixelId = "939623849833574";
export const accessToken =
  "EAAH5DifGlU4BOxo4sPX0rPG9CNcEBxKgO4QGNf8rRlDXN6F11VI3MTXa1XcvCMfCitaRpyeblKSJRpomWsZBw0YI4tkAscZCWz5eTrmLjJhtPOGBABZBvMGZCI5nLIduDdxbSp5ctomTEl75A6IKGs7T9cqtqseNmWDf4gxkFZCaaBqDLbR6vxIe0FkGIkZB34fgZDZD";

export const fbApiUrl = `https://graph.facebook.com/v18.0/${pixelId}/events?access_token=${accessToken}`;
